<div class="profile">
  <h1>Profile</h1>
  <div class="profile__content">
    <form (submit)="onSubmit()" [formGroup]="userForm">
      <div class="profile__row flex-wrap">
        <div class="profile__col">
          <app-input-wrapper>
            <label>Name</label>
            <input
              type="text"
              formControlName="name"
              placeholder="Enter Name"
              inNoWhitespace
            />
            <span
              *ngIf="userForm.get('name')?.errors?.['required']&&(userForm.get('name')?.dirty||userForm.get('name')?.touched)"
            >
              Name is required
            </span>
          </app-input-wrapper>
        </div>
        <div class="profile__col">
          <app-input-wrapper>
            <label>Email</label>
            <input
              type="text"
              [attr.disabled]="true"
              [readonly]="true"
              formControlName="email"
              placeholder="Enter email"
              inNoWhitespace
            />
          </app-input-wrapper>
        </div>
        <div class="profile__col">
          <app-input-wrapper>
            <label>Phone No.</label>
            <input
              type="text"
              formControlName="phone"
              placeholder="Enter phone"
              inNoWhitespace
              mask="(000) 000-0000"
            />
            <span
              *ngIf="userForm.get('phone')?.errors?.['required']&&(userForm.get('phone')?.dirty||userForm.get('phone')?.touched)"
            >
              Phone No. is required
            </span>
            <span
              *ngIf="userForm.get('phone')?.errors?.['mask']&&(userForm.get('phone')?.dirty||userForm.get('phone')?.touched)"
            >
              Phone No. is invalid
            </span>
          </app-input-wrapper>
        </div>
        <div class="profile__col">
          <app-input-wrapper>
            <label>Role</label>
            <select formControlName="role">
              <ng-container *ngFor="let role of roles">
                <option [value]="role.value">{{ role.label }}</option>
              </ng-container>
            </select>
          </app-input-wrapper>
        </div>
      </div>
      <div class="profile__footer flex justify-between">
        <app-button
          type="button"
          label="Password Change"
          (action)="togglePasswordModal(true)"
        ></app-button>
        <app-button
          [isDisabled]="
            isLoading ||
            (userForm.get('name')?.value === initialDetails?.name &&
              userForm.get('phone')?.value === initialDetails?.phone)
          "
          type="submit"
          label="Submit"
        >
          <app-button-loader
            *ngIf="isLoading"
            postfixContent
          ></app-button-loader>
        </app-button>
      </div>
    </form>
  </div>
</div>

<app-modal
  [modalTitle]="'Change Password'"
  (closeModal)="togglePasswordModal(false)"
  *ngIf="showPasswordModal"
>
  <app-change-password
    (close)="togglePasswordModal(false)"
  ></app-change-password>
</app-modal>
